import styled from "styled-components";

// The remaining styles are shared styles amongst the modal's "steps"

export const StyledMainContainer = styled.div`
  background-color: #ffffff;
  box-sizing: border-box;
  padding: 16px;
  min-height: 345px;
`;

export const Label = styled.div`
  color: #212530;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 4px;
`;

export const HelperText = styled.div`
  color: ${p => p.color || "#797b81"};
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 8px;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;

  input {
    cursor: pointer;
  }

  > div {
    margin-left: 8px;
    margin-bottom: 0px;
  }
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;
